export default "__VITE_ASSET__CwoTmuZG__"